<template>
    <div class="confidence">
        <i v-if="value > 0"
           class="confidence__icon fas fa-circle" />
        <i v-else
           class="confidence__icon fas fa-circle-notch" />
        <i v-if="value > 1"
           class="confidence__icon fas fa-circle" />
        <i v-else
           class="confidence__icon fas fa-circle-notch" />
        <i v-if="value > 2"
           class="confidence__icon fas fa-circle" />
        <i v-else
           class="confidence__icon fas fa-circle-notch" />
        <i v-if="value > 3"
           class="confidence__icon fas fa-circle" />
        <i v-else
           class="confidence__icon fas fa-circle-notch" />
    </div>
</template>

<script>

export default {

    props: {
        value: {
            type: Number,
            default: 0,
            required: true,
        },
    },

    beforeMount() {
        if (this.value > 10 || this.value < 0)
            throw new TypeError('The provided value must be a number from 0 - 10')
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.confidence {
    position: absolute;
    z-index: z-index('raised');

    @include element('icon') {
        margin-left: 0.1em;
    }
}

</style>
